



// import { WebsocketService } from './../../services/websocket.service';

import { AsignafolioService } from 'src/app/services/asigafolios/asignafolio.service';
import { PaymentsService } from './../../services/payments.service';

import { Pescador } from './../../models/pescador';
import { Component, OnInit, ViewChild, EventEmitter, Output, Input, AfterViewChecked } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PescadorService } from '../../services/solicitante/pescador.service';
import { ListalicenciasService } from '../../services/solicitante/listalicencias.service';
import { Licencia } from '../../models/licencia';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog, MatDialogConfig} from '@angular/material';
import { Solicitante } from '../../models/solictante';
import { ReciboComponent } from '../recibo/recibo.component';
import {Router} from '@angular/router';
import { SolicitanteService } from '../../services/solicitante/solicitante.service';
import { formatDate } from '@angular/common';


import * as moment from 'moment';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { EmailService } from 'src/app/services/email/email.service';
import { RecibopublicoComponent } from '../recibopublico/recibopublico.component';





declare let paypal: any;














@Component({
  selector: 'app-pescadores',
  templateUrl: './pescadores.component.html',
  styleUrls: ['./pescadores.component.css']
})
export class PescadoresComponent implements OnInit, AfterViewChecked {
  @Input()
  orderlimpiarlista: boolean;
  seleccionFechaactual: Date;



// VARIABLES DE PAYPAL
  addScript = false;
  paypalLoad = true;
  finalAmount = 1;
  // --------------------


  // @Output()
  // enviar: EventEmitter <boolean> = new EventEmitter <boolean>();



  public preciopublico: number;
  public idpermiso: number;
  fechainiciopesca: string;
  opcionSeleccionado: Licencia;
  forma: FormGroup;
  licencia: Licencia[];
  listapescador: Pescador[];
  totalListadoPescador: number;
  cantidadRegistro = 0;
  pageActual = 1;
  previousPage: number;
  showPagination: boolean;
  totalsumatoriatabla = 0;
  defaultValue = 5;

  nombre: string;
  apellido: string;
  ciudad: string;
  estado: string;
  tipolicencia: string;
  costolicencia: number;
  nombreArchivoCreado = '';
  folioconsecututivoEfectivo = '';



  idregistro: string;
  idsolicitantes: string;
  mensaje: string ;

  startDate: string;
  datev: string;
  numeroConfirmacionStripe = '';



  constructor( private http: HttpClient,
               public pescadorService: PescadorService,
               public listalicenciasService: ListalicenciasService,
               private dialog: MatDialog,
               private solicitanteService: SolicitanteService,
               private asignafolioService: AsignafolioService,
               private emailService: EmailService,
               private router: Router,
             //  public wsService: WebsocketService,

               ) {

  }


  paypalConfig = {
    env: environment.seleccionPago,
    client: {
      sandbox: environment.apiSandbox,
      production: environment.apiProduccion
    },
    locale: 'en_US',
    style: {
      size: 'large',
      color: 'gold',
      shape: 'pill',
      label: 'pay',
      tagline: 'true',
     fundingicons: 'true'
    },

    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            { amount: { total: this.finalAmount, currency: 'USD' },
            description: 'Compra de permisos de Pesca' }
          ]
        },

      });
    },
    onAuthorize: (data, actions) => {

      return actions.payment.execute().then((payment) => {
        // Do something when payment is successful.
       // console.log (payment);
        this.numeroConfirmacionStripe = payment.id;



               // aqui se checara la creacin de id unico para controal r lsopagos
          // *************************************************************
        this.asignafolioService.crearFolios()
          .subscribe ( resp => {
           const fechaFolio = resp.fecha;
         //  console.log ('fecha folio' + fechaFolio);
           const folioconsecutivo = resp.folioconsecutivo;
           this.folioconsecututivoEfectivo = fechaFolio.concat('-', folioconsecutivo );



          // aqui actualziare el solicitante a true

          // con esto lo enviare a al proceso de creaccion de licencis

         //  console.log ('nombre del archivo creado desde el servidor', this.nombreArchivoCreado);
           this.solicitanteService.solicitanteAceptado( this.folioconsecututivoEfectivo,
            this.numeroConfirmacionStripe, 'No Generado', '')
                .subscribe ( resp => {
                //  this.show = false;
               //   this.onClose();
            //   this.wsService.emit ('solicitud_pagada');
              // console.log (' numero ocnfirmado y ceado');
              // this.sendMensaje ('solicitudPagada');
           //   this.enviaemail();
              return true ;
                });

 });

 // aqui se hara le proceso de actualziacion del solicitante



        Swal.fire({

  title: 'Confirmation of receipt of information and payment',
  text:  'We have received the necessary information to issue the requested licenses and the corresponding payment. This is your Confirmation Number. ' + this.numeroConfirmacionStripe +' Your documents will be prepared within 24 hours and you will receive the licenses in PDF format via email. If you require your fishing licenses as soon as possible, please contact us through info@sportfishingmx.com or through our Contact Us link.',
  icon: 'info',

  confirmButtonText: 'Ok',
  cancelButtonText: 'Close window'
}).then((result) => {

  if (result.value) {

    // this.router.navigate(['']);
    this.abrirModal();

  // For more information about handling dismissals please visit
  // https://sweetalert2.github.io/#handling-dismissals
  } else if (result.dismiss === Swal.DismissReason.cancel) {
    Swal.fire(

      'Thanks for your purchase'


    );
   // this.router.navigate(['../fantasma']);
  }
});


      });
    }
  };




  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
        this.paypalLoad = false;
      });
    }
  }



  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagElement = document.createElement('script');
      scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }









  ngOnInit() {


    this.seleccionFechaactual = new Date();
    this.nombreArchivoCreado = '';

    // this.getMessages().subscribe ( msg => {

    //   console.log ( 'mesnaje del servidor', msg );
    // });


    this.forma = new FormGroup({
      nombre: new FormControl(null, Validators.required),
      apellido: new FormControl(null, Validators.required),
      ciudad: new FormControl(null, Validators.required),
      estado: new FormControl(null, Validators.required),
      tipolicencia: new FormControl(null, Validators.required),
      costolicencia: new FormControl(null, Validators.required),
      fechainiciopesca: new FormControl( this.seleccionFechaactual),





    });



    // this.licencia = this.listalicenciasServices.getLicencias();


    // this.licencia = [    { idpermiso: 1, descripcion: '1 Dia', costo: 10 },
    //   {idpermiso: 2, descripcion: '1 Semana', costo: 11 },





    this.listalicenciasService.getLicenciaspagina()
       .subscribe(
         licen => {
            this.licencia = licen;
          //  console.log (this.licencia);
          },

         );


    // this.opcionSeleccionado = (eny);







    // console.log ('aqui entro');
    const valoID = localStorage.getItem ('idsolicitante') || '000';
    console.log ( valoID );
    if (valoID !== '000') {
    this.muestratodospescador();
    }




  }









  registrarPescador() {

    this.idregistro = localStorage.getItem('idsolicitante');
    this.idsolicitantes = localStorage.getItem('idsolicitante');


    if ( this.forma.invalid) {
      console.log ('aqui me meti');
      return;
      }
    console.log ('pase');
    // console.log ('aqui esta 2');
    const pescador = new Pescador(
        this.forma.value.nombre,
        this.forma.value.apellido,
        this.forma.value.ciudad,
        this.forma.value.estado,
        this.opcionSeleccionado.descripcion,
        this.forma.value.costolicencia,
       this.forma.value.fechainiciopesca,
       this.idsolicitantes,
       this.idregistro



      );

    const valoID = localStorage.getItem ('idsolicitante') || '000';



    this.pescadorService.crearPescador( pescador )
      .subscribe ( resp => {
        this.forma.reset();

        this.pescadorService.nuestraTodosPescadores(valoID)
        .subscribe(

          listado => {
             this.listapescador = listado;
             this.totalsumatoriatabla = this.listapescador.reduce((acc,  obj,  ) => acc + (obj.costolicencia), 0);
             this.finalAmount = this.totalsumatoriatabla;
            // console.log ( 'sumatorioa' + this.totalsumatoriatabla );
             if (this.totalsumatoriatabla === 0) {
                this.listapescador = [];
              }
           },
           err => console.log (err)
          );

        //  this.nombre='demostracion';
        this.nombre = '';
        this.apellido = '';
        this.ciudad = '';
        this.estado = '';
        this.tipolicencia = '1';
        this.costolicencia = 0;
        // this.seleccionFechaactual = new Date();


      });

    }








muestratodospescador() {
  const valoID = localStorage.getItem ('idsolicitante') || '000';

  this.pescadorService.nuestraTodosPescadores ( valoID )
    .subscribe(
      listado => {


        this.totalListadoPescador = this.pescadorService.totalListadoPescador;



        console.log ('listado********', listado);
        this.listapescador = listado;


  // Calculamos el TOTAL
        this.totalsumatoriatabla = this.listapescador.reduce((acc,  obj,  ) => acc + (obj.costolicencia), 0);
        this.finalAmount = this.totalsumatoriatabla;






       },
       err => console.log (err)
      );
}



Inicializadesplieguetablas() {

  this.listapescador = [];
  this.totalsumatoriatabla = 0;


}


// public pageChange(event: number): void {
//   this.pageActual = event;

//   this.muestratodospescador();


// }




// realizarPago() {

//   // this.enviar.emit (false);
//   const dialogConfig = new MatDialogConfig();
//   dialogConfig.disableClose = true;
//   dialogConfig.autoFocus = true;
//   dialogConfig.width = '60%';
//   dialogConfig.height = '90%';

//   dialogConfig.data = {
//     pagar: this.totalsumatoriatabla,
//     email: this.solicitanteService.solicitante.email,
//     idsolicitante: this.solicitanteService.solicitante._id,

// };


//   this.dialog.open (PaymentsComponent,  dialogConfig );
// }




deleteRow( list: Pescador ) {
  this.pescadorService.borraPescador(list._id )
  .subscribe ( resp => {
    this.muestratodospescador();
  });
}

fechaActual() {

  const format = 'yyyy-MM-dd';
  const locale = 'en-US';



  const d = new Date();
  const dia = d.getDate();
  const mes =  ('0' + (d.getMonth() + 1));
  const anio = d.getFullYear();
  const fechatotal = dia + '/' + mes + '/' + anio;
  const dateObj = new Date(fechatotal);
  this.startDate = formatDate(dateObj, format, locale);
  console.log ('lafecha actual es' + this.startDate);


}


onChange(event: any, newDate: any) {
console.log (newDate);
}



abrirModal() {

  const dialogRef = this.dialog.open(RecibopublicoComponent, {
    panelClass: 'mensaje',
    disableClose: true,
    data: {
      listadospescadores: this.listapescador,
      totalsumatoria: this.totalsumatoriatabla
    }
  });
}

verdemo(list) {
  const d = new Date(list.fechainiciopesca);
  d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
  return moment(d).format('MM-DD-YYYY') ;

}


// sendMensaje(mensaje: string ) {
//   this.wsService.emit (mensaje);

// }



// getMessages() {
//   return this.wsService.listen('mensaje-nuevo');
// }


enviaemail() {
  // const nombreArchivocompleto = this.nombreArchivoPDF;
   const subJet =  "se ha registrado un deposito del publico en general" ;

  // const direccionemail = this.txtemail;
//   const filepdf = nombreArchivocompleto;

 //  this.nombreArchivoPDF = filepdf;
   this.emailService.sendEmailTuripes(subJet)
          .subscribe(
            licen => {
               // alert ('listo');
              // this.botonFinalizadeshabilitado = false;
             },

            );
     }



}
